import React from 'react';

const RadioButton = (props) => {

    return (<>
        {props &&
        <div className="form-check ml-2">
            <input
                id={props.id}
                className="form-check-input"
                type="radio"
                name={props.group}
                checked={props.value==props.field.value}
                value={props.value}
                onChange={(e)=>{props.form.setFieldValue(props.field['name'],e.target.value)}}
            />
            <label className="form-check-label mr-1" htmlFor={props.id}>
                {props.title}
            </label>
        </div>

        }
    </>)
};

export default RadioButton;